import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import { DEFAULT_TIMEZONE } from '../common/constants';
import { Nullable } from '../common/types';

export type EntityType =
  | 'VectorSystem'
  | 'FarmIT'
  | 'AutomaticMilkFilter'
  | 'AstronautA5'
  | 'Discovery';

export type EntityInformationSliceInitialState = {
  entityInfo: Nullable<{
    entityId: string;
    farmId: string;
    farmName: string;
    farmTimeZone: string;
    name: string;
    type: EntityType;
  }>;
  errorMessage: string;
  requestUuid?: number;
};

export const initialState: EntityInformationSliceInitialState = {
  entityInfo: null,
  errorMessage: '',
  requestUuid: undefined,
};

export const entityInformationSlice = createSlice({
  name: 'entityInfo',
  initialState,
  reducers: {
    getEntityInfoSuccess: (
      state,
      action: PayloadAction<EntityInformationSliceInitialState['entityInfo']>,
    ) => {
      state.entityInfo = action.payload;
      state.errorMessage = '';
    },
    getEntityInfoError: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },
    resetEntityInfo: (state) => {
      state.entityInfo = initialState.entityInfo;
    },
    resetFarmNameInBreadcrumbsComponent: (state) => {
      if (state.entityInfo) {
        state.entityInfo.farmName = '';
        state.entityInfo.name = '';
      }
    },
  },
});

export const getEntityInfoRequest = createAction<{ entityId: string }>(
  'entityInfo/getEntityInfo',
);

export const {
  getEntityInfoSuccess,
  getEntityInfoError,
  resetEntityInfo,
  resetFarmNameInBreadcrumbsComponent,
} = entityInformationSlice.actions;

export const entityInformationSelectors = {
  selectEntityInfo: (state: RootState) => state.entityInfo?.entityInfo,
  selectFarmTimeZone: (state: RootState) =>
    state.entityInfo?.entityInfo?.farmTimeZone || DEFAULT_TIMEZONE,
  isFarmTimeZoneProvided: (state: RootState) =>
    !!state.entityInfo?.entityInfo?.farmTimeZone,
};

export default entityInformationSlice.reducer;
